<div class="stepperdiv common-popup-ui">
  <div class="position-relative">
    <div class="position-relative w-100 timerset">
      <div *ngIf="isShown" class="topright-datetime-status" id="timerid">
        <div class="xmtime" *ngIf="MinutesVaidation == 0">
          <span *ngIf="firstFormGroup.value.Hours <10">0{{firstFormGroup.value.Hours}}</span>
          <span *ngIf="firstFormGroup.value.Hours >=10">{{firstFormGroup.value.Hours}}</span>
          : 00
        </div>
        <div class="xmtime" *ngIf="MinutesVaidation != 0">
          <span *ngIf="firstFormGroup.value.Hours <10">0{{firstFormGroup.value.Hours}}</span>
          <span *ngIf="firstFormGroup.value.Hours >=10">{{firstFormGroup.value.Hours}}</span> :
          <span *ngIf="firstFormGroup.value.Minutes <10">0{{firstFormGroup.value.Minutes}}</span>
          <span *ngIf="firstFormGroup.value.Minutes >=10">{{firstFormGroup.value.Minutes}}</span>
        </div>
        <div class="date-xmduration d-flex align-items-center">
          <p>{{ firstFormGroup.value.Date | date : "dd-MM-yyyy" }}</p>
          <p>
            {{ firstFormGroup.value.StartTime }} To
            {{ firstFormGroup.value.EndTime }}
          </p>
        </div>
      </div>
    </div>
    <mat-horizontal-stepper linear #stepper>
      <mat-step [stepControl]="$any((timeCheck || IsTimeValidToSubmit || ZeroValForNext) ? null : firstFormGroup)"
        [completed]="(timeCheck || IsTimeValidToSubmit || ZeroValForNext) ? false : firstFormGroup.valid">
        <form [formGroup]="firstFormGroup">
          <ng-template matStepLabel><i class="fa fa-calendar"></i><span>{{
              TestConstant.SCHEDULE_EXAM_WIZARD_LABEL
              }}</span></ng-template>
          <div class="inner-stepper-content">
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group mb-4">
                  <mat-label>{{ TestConstant.EXAM_NAME}}
                    <span class="form-control-danger">*</span></mat-label>
                  <input class="form-control" maxlength="100" matInput formControlName="TestName"
                    placeholder="Enter Exam Name" oninput="this.value = this.value.replace(/^\s+/g, '')" required />
                  <span class="text-danger"
                    *ngIf="submitFirstFormButton && firstFormControl['TestName'].errors?.['required']">
                    Exam name is required
                  </span>

                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group mb-4 date">
                  <mat-label>{{ TestConstant.Date }}
                    <span class="form-control-danger">*</span></mat-label>
                  <mat-form-field class="example-full-width form-control">
                    <input matInput [matDatepicker]="picker" formControlName="Date" id="date" [min]="now" readonly
                      [(ngModel)]="selectedDate1" (click)="openDatepicker()" (dateChange)="onDateValueChange($event)" />
                    <mat-datepicker-toggle matIconSuffix [for]="picker">
                      <img src="../../../../assets/img/datepicker.svg" alt="image" matDatepickerToggleIcon />
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <span class="text-danger"
                    *ngIf="submitFirstFormButton && firstFormControl['Date'].errors?.['required']">
                    Exam date is required
                  </span>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group mb-4">
                  <mat-label>{{ TestConstant.StartTime
                    }}<span class="form-control-danger">*</span></mat-label>
                  <div class="input-group time" id="timepicker" *ngIf="examDate">
                    <input class="form-control" aria-label="12hr format" formControlName="StartTime" id="appt"
                      [(ngModel)]="selectedTime" [min]="strTime" name="appt" [ngxTimepicker]="default" required
                      readonly />
                    <ngx-material-timepicker (timeSet)="onStartTimeSelected($event)" #default></ngx-material-timepicker>
                    <span class="text-danger"
                      *ngIf="submitFirstFormButton && firstFormControl['StartTime'].errors?.['required']">
                      Start time is required
                    </span>
                    <span *ngIf="timeCheck" class="text-danger">
                      Start time must be lesser than end time
                    </span>
                  </div>
                  <div class="input-group time" id="timepicker" *ngIf="!examDate">
                    <input class="form-control" aria-label="12hr format" formControlName="StartTime" id="appt"
                      [(ngModel)]="selectedTime" name="appt" [ngxTimepicker]="default" required readonly />
                    <ngx-material-timepicker (timeSet)="onStartTimeSelected($event)" #default></ngx-material-timepicker>
                    <span class="text-danger"
                      *ngIf="submitFirstFormButton && firstFormControl['StartTime'].errors?.['required']">
                      Start time is required
                    </span>
                    <span *ngIf="timeCheck" class="text-danger">
                      Start time must be lesser than end time
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group mb-4">
                  <mat-label>{{ TestConstant.EndTime
                    }}<span class="form-control-danger">*</span></mat-label>
                  <div class="input-group time" id="timepicker">
                    <input class="form-control" aria-label="12hr format" [ngxTimepicker]="default1"
                      formControlName="EndTime" id="appt" name="appt" required readonly>
                    <ngx-material-timepicker (timeSet)="onEndTimeSelected($event)" #default1></ngx-material-timepicker>
                    <span class="text-danger"
                      *ngIf="submitFirstFormButton && firstFormControl['EndTime'].errors?.['required']">
                      End time is required
                    </span>
                    <span class="text-danger" *ngIf="timeCheck">
                      End time must be greater than start time
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group mb-4">
                  <mat-label>Exam Duration<span class="form-control-danger">*</span></mat-label>
                  <div class="position-relative">
                    <input type="number" class="form-control" maxlength="2" matInput formControlName="Hours"
                      placeholder="0" (change)="ValidHourMinuteDuration()" (input)="validHourForExamDuration($event)"
                      oninput="this.value = this.value.substring(0, 2).replace(/[^0-9]|^0+(?=\d)|(?<=\s)0+(?=\d)|(?<=\d)0+(?=\s)|(?<=\d)\s+/g, '').replace(/^(\d{1,2})(\d.*)?/, function(_, p1, p2) { return p1 > 23 ? '23' : p1 + (p2 || ''); })">
                    <span class="hour-btn">Hours</span>
                    <span *ngIf="MaxHourError" class="text-danger">Hour should be in above duration
                    </span>
                    <span *ngIf="(MaxDurationExanInMilliSecond/3600000<0)" class="text-danger">
                      Hours is invalid</span>
                    <span class="text-danger"
                      *ngIf="submitFirstFormButton && firstFormControl['Hours'].errors?.['required']">
                      Exam duration is required
                    </span>

                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group mb-4">
                  <mat-label>&nbsp;<span class="form-control-danger"></span></mat-label>
                  <div class="position-relative">
                    <input type="number" class="form-control" maxlength="2" matInput formControlName="Minutes"
                      placeholder="0" (change)="ValidHourMinuteDuration()" (input)="validMinuteForExamDuration($event)"
                      oninput="this.value = this.value.substring(0, 2).replace(/[^0-9]|^0+(?=\d)|(?<=\s)0+(?=\d)|(?<=\d)0+(?=\s)|(?<=\d)\s+/g, '').replace(/^(\d{1,2})(\d.*)?/, function(_, p1, p2) { return p1 > 59 ? '59' : p1 + (p2 || ''); })">
                    <span class="hour-btn">Minutes</span>
                    <span *ngIf="MaxMinuteError" class="text-danger">Minutes should be set according to hour selection
                    </span>
                    <span *ngIf="(MaxDurationExanInMilliSecond/60000<0)" class="text-danger">
                      Minutes is invalid</span>
                    <span class="text-danger"
                      *ngIf="submitFirstFormButton && firstFormControl['Minutes'].errors?.['required']">
                      Exam duration is required
                    </span>
                    <span
                      *ngIf="ZeroHourValidation && (firstFormControl['Minutes'].dirty || firstFormControl['Minutes'].touched)"
                      class="text-danger">Exam duration should not be zero</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="wizard-btn-wrap mx-auto text-center">
          <button class="btn common-button m-2" mat-button matStepperNext
            [disabled]="ZeroValForNext || timeCheck || IsTimeValidToSubmit" (click)="submitFirstForm()">
            {{ CommonConstant.NEXT }}
          </button>
        </div>
      </mat-step>
      <mat-step
        [stepControl]="$any((!totalQuestionCheck || !cutoffCheck ||  IsQuestionSetSelected) ? null : secondFormGroup)"
        [completed]="(!totalQuestionCheck || !cutoffCheck ||  IsQuestionSetSelected) ? false : secondFormGroup.valid">
        <form [formGroup]="secondFormGroup">
          <ng-template matStepLabel><i class="fa fa-question"></i><span>{{
              TestConstant.QUESTION_SETS_WIZARD_LABEL
              }}</span></ng-template>
          <div class="inner-stepper-fullcontent">
            <div class="row align-items-center">
              <div class="col-md-10 col-xl-6 col-lg-8 mx-auto">
                <div class="form-group mb-4">
                  <mat-label>{{ TestConstant.SELECT_QUESTION_SETS
                    }}<span class="form-control-danger">*</span></mat-label>
                  <ng-multiselect-dropdown #yourDropdown class="dropdown-btn form-control form-control-lg"
                    [placeholder]="'Select Question Set Type'" [(ngModel)]="selectedQuestionSetItems"
                    [ngModelOptions]="{ standalone: true }" [settings]="dropdownQuestionSetSettings"
                    [data]="questionSetList" (onSelect)="onItemSelectQuestionSet($event)"
                    (onDeSelect)="onItemDeSelectQuestionSet($event)" (onDeSelectAll)="onUnSelectAllQuestionSet()"
                    (onSelectAll)="onSelectAllQuestionSet($event)">

                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>
            <div class="quesetlist listdisplayview">
              <div class="showlist-quesset">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="noquestion" *ngIf="IsQuestionSetSelected">
                      <h4>There is no select any question set yet!!</h4>
                      <p>Select question set as given above option.</p>
                    </div>
                  </div>
                  <div formArrayName="questionSet">
                    <div class="row mb-4 align-items-start">
                      <div class="col-lg-3 col-md-4 col-sm-6 col-12"
                        *ngFor="let set of questionSet?.controls; let i = index" [formGroupName]="i">
                        <div class="form-group">
                          <mat-label class="questionsetlabel">
                            {{ questionSetLabel[i].labels
                            }}<span class="form-control-danger">*</span><span
                              *ngIf="ParagraphNote && (questionSetLabel[i].questionSetName == ('Paragraph'))">
                              <i class="fa-solid fa-circle-info ms-2 fs-5"
                                title="Paragraph contains 5 questions"></i></span></mat-label>
                          <div class="input-group mb-3 red-minus">
                            <input type="number" class="form-control" formControlName="numberOfQuestion"
                              oninput="this.value = this.value.replace(/[^\d]+/g, '')" aria-label="Username"
                              aria-describedby="basic-addon1" (keyup)="
                                onInputKeyUp($event, questionSetLabel[i].labels)
                              "
                              (focusout)="focusOutFunction($event, questionSetLabel[i].labels); onInputKeyUp($event, questionSetLabel[i].labels)" />

                            <div class="minus-icon input-group-text" id="basic-addon1">
                              <i class="cursor-pointer fa-solid fa-minus" (click)="
                                  removeQuestionSet(questionSetLabel[i].labels)
                                "></i>
                            </div>
                            <span class="text-danger"
                              *ngIf="submitSecondFormButton && secondFormControl['questionSet'].errors?.['required']">Required!!</span>

                            <span class="text-danger"
                              *ngIf="optionCheck(i).controls['numberOfQuestion'].errors?.['required']
                                                && (optionCheck(i).controls['numberOfQuestion'].dirty || optionCheck(i).controls['numberOfQuestion'].touched)">
                              Question number is required.
                            </span>
                            <span class="text-danger"
                              *ngIf="optionCheck(i).controls['numberOfQuestion'].errors?.['min'] 
                                                && (optionCheck(i).controls['numberOfQuestion'].dirty || optionCheck(i).controls['numberOfQuestion'].touched)">
                              Question number must be greater than 0.
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="displayvalue">
              <div class="displayvaluelabel d-flex align-items-center mb-2 mb-xl-2">
                <p>Total Number of Questions :</p>
                <div class="blue valuebox">{{ totalQuestions }}</div>
              </div>
              <div class="displayvaluelabel d-flex align-items-center mb-2 mb-xl-2">
                <p>Passing Marks :</p>
                <input class="blue valuebox" style="background: white !important; color: black !important;" matInput
                  type="number" #CutOff oninput="this.value = this.value.replace(/[^\d]+/g, '')"
                  (change)="GetCutOff(CutOff.value)" maxlength="3" placeholder="0" inputmode="numeric" pattern="[0-9]*"
                  required />
              </div>
              <div class="cleardeleteall">
                <a (click)="clearAll()" title="Clear All" class="text-grey">{{
                  TestConstant.CLEAR_ALL
                  }}</a>
                /
                <a (click)="deleteAll()" title="Delete All" class="text-danger">{{
                  TestConstant.DELETE_ALL
                  }}</a>
              </div>
            </div>
          </div>
        </form>
        <div class="wizard-btn-wrap mx-auto text-center">
          <button class="btn btn-border common-button m-2" (click)="isShown = false" mat-button matStepperPrevious>
            {{ CommonConstant.PREVIOUS }}
          </button>
          <button class="btn common-button m-2" mat-button matStepperNext
            [disabled]="!totalQuestionCheck || !cutoffCheck ||  IsQuestionSetSelected || !this.secondFormGroup.valid"
            (click)="submitSecondForm()">
            {{ CommonConstant.NEXT }}
          </button>
        </div>
      </mat-step>
      <mat-step [stepControl]="$any((!bindSelectedCollegeFlag()) ? null : thirdFormGroup)"
        [completed]="(!bindSelectedCollegeFlag()) ? false : thirdFormGroup.valid">
        <form [formGroup]="thirdFormGroup">
          <ng-template matStepLabel><i class="fa fa-university"></i><span>{{ TestConstant.College
              }}</span></ng-template>
          <div class="inner-stepper-fullcontent">
            <div class="row align-items-center justify-content-center">
              <div class="col-md-10 col-xl-6 col-lg-8 mx-auto mb-4">
                <div class="input-group searchbar-field">
                  <input type="search" class="form-control rounded" placeholder="Search..." aria-label="Search"
                    aria-describedby="search-addon" (keyup)="search($event)" />
                  <span class="input-group-text border-0" id="search-addon">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
              </div>
              <span *ngIf="collegeNotFound" class="text-grey" style="text-align: center;">No record found</span>
              <div class="col-md-12">
                <div class="college-checkbox-list row align-items-start gap-3 justify-content-start">
                  <ng-container *ngFor="let college of filterArrayList; let i = index">
                    <div class="widthdataset p-0 m-0">
                      <div class="form-check collegelist-checkbox">
                        <mat-label class="form-check-label" for="clg1">
                          <div class="collegecheckbox-info">
                            <img src="{{ college.collegeUrl }}" alt="" class="img-fluid me-3"
                              (error)="handleImageError($event)" />
                            <div class="clgnamelocation">
                              <h5>{{ college.collegeName }}</h5>
                              <p>{{ college.city }},{{ college.state }}</p>
                            </div>
                          </div>
                        </mat-label>
                        <input class="form-check-input" type="checkbox" [(ngModel)]="college.checked"
                          [ngModelOptions]="{ standalone: true }" value="{{ college.id }}"
                          (change)="oncollegeListCheckboxChange($event, i)" />
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="wizard-btn-wrap mx-auto text-center">
          <button class="btn btn-border common-button m-2" mat-button matStepperPrevious>
            {{ CommonConstant.PREVIOUS }}
          </button>
          <button class="btn common-button m-2" mat-button matStepperNext [disabled]="!bindSelectedCollegeFlag()"
            (click)="bindSelectedCollege();">
            {{ CommonConstant.NEXT }}
          </button>
        </div>
      </mat-step>
      <mat-step [stepControl]="$any((!havingBatches()) ? null : fourthFormGroup)"
        [completed]="(!havingBatches()) ? false : fourthFormGroup.valid">
        <form class="pb-0" [formGroup]="fourthFormGroup">
          <ng-template matStepLabel><i class="fa fa-graduation-cap" (click)="bindSelectedCollege()"></i><span
              (click)="bindSelectedCollege()">{{ TestConstant.BATCH_WIZARD_LABEL
              }}</span></ng-template>
          <div class="inner-stepper-fullcontent">
            <div class="row align-items-center justify-content-center">
              <div class="col-sm-12 col-xl-6">
                <div class="form-group mb-4">
                  <mat-label>{{ TestConstant.SELECT_COLLEGE }}</mat-label>
                  <select id="queset-select" class="form-control form-select ng-valid form-control-lg"
                    formControlName="CollegeId" (change)="onChangeCollege($any($event.target).value)">
                    <option value="">{{ TestConstant.SELECT_COLLEGE }}</option>
                    <ng-container *ngFor="let college of selectedCollege">
                      <option [value]="college.id">
                        {{ college.collegeName }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
              <div class="col-sm-12 col-xl-6">
                <div class="form-group mb-4">
                  <mat-label>{{ TestConstant.SELECT_BATCH }}</mat-label>
                  <ng-multiselect-dropdown #collegeBatchSelect
                    class="dropdown-btn form-control batchesMultiSelect form-control-lg"
                    [settings]="CollegeBatchSettings" [placeholder]="'Select batch of selected colleges'"
                    [(ngModel)]="checked" [ngModelOptions]="{standalone: true}"
                    (onSelect)="onSelectCollegebatch1($event)" (onDeSelect)="onDeSelectBatch1($event)" (onDeSelectAll)="onDeSelectAllBatch1($event)
                    " (onSelectAll)="onSelectAllCollegeBatch($event)">
                  </ng-multiselect-dropdown>
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="listdisplayview p-3">
                  <div class="row">
                    <div class="col-xl-4 col-lg-6 col-md-6 col-12 collegeCard"
                      *ngFor="let card of SelectedCollegeDataList;let i = index;">
                      <div class="select_college_list1" id="{{ 'Card' + card.collegeId }}"
                        *ngIf="card.Batches.length > 0">
                        <div class="cursor-pointer singleminus-icon" (click)="onCloseCollegeDiv(card.collegeId)">
                          <i class="fa-solid fa-minus college"></i>
                        </div>
                        <div class="wrap-clgname">
                          <img [src]="card.CollegeData.collegeUrl" alt="" class="img-fluid me-3"
                            (error)="handleImageError($event)">
                          <div class="clgnamelocation">
                            <h5>{{card.CollegeData.collegeName}}</h5>
                            <p>{{card.CollegeData.city}},{{card.CollegeData.state}}</p>
                          </div>
                        </div>
                        <div class="selectbatchinfo">
                          <h4>Select Batches</h4>
                          <ul class="list select_batch_list_${collegeId}">
                            <li class="selectbatch-name position-relative"
                              *ngFor="let batch of card.Batches;let i = index;">
                              <p>{{batch.BatchName}}</p>
                              <div class="cursor-pointer singleminus-icon "
                                (click)="onDeSelectBatch(batch.BatchId,card.collegeId)">
                                <i class="fa-solid fa-minus "></i>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="notfound-list d-none">
                    <h5>There is no select any question set yet!!</h5>
                    <p>Select question set as given above option.</p>
                  </div>
                </div>
                <div class="displayvalue positionvalue mb-4" style="position: relative">
                  <div class="cleardeleteall">
                    <a (click)="deleteAllBatches()" title="Delete All" class="text-danger">{{
                      TestConstant.DELETE_ALL
                      }}</a>
                  </div>
                  <div class="displayvaluelabel d-flex align-items-center">
                    <p>Total Students :</p>
                    <div class="green valuebox" title="View student list" style="min-width: 135px; cursor: pointer;" [style.cursor]="havingBatches() ? 'pointer': 'context-menu'" (click)="havingBatches() ? getStudentList() : null">
                      {{ totalstudent }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="wizard-btn-wrap mx-auto text-center">
          <button class="btn btn-border common-button m-2" mat-button matStepperPrevious>
            {{ CommonConstant.PREVIOUS }}
          </button>
          <button class="btn common-button m-2" mat-button (click)="saveTest()" [disabled]="!havingBatches()">
            {{ CommonConstant.FINISH }}
          </button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>